module.exports = __webpack_public_path__ + "assets/img/EU_logo.svg";